import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import { useRoles } from '../../hooks/useRoles';
import type { PermissionCheck } from '../../types/auth.types';

interface PermissionRouteProps {
    requiredPermissions?: PermissionCheck[];
    requiredRoles?: string[];
    children?: React.ReactNode;
}

export const PermissionRoute: React.FC<PermissionRouteProps> = ({
    requiredPermissions,
    requiredRoles,
    children,
}) => {
    const { hasAnyPermission } = usePermissions();
    const { hasAnyRole } = useRoles();
    const location = useLocation();

    const permissionOk = !requiredPermissions?.length || hasAnyPermission(requiredPermissions);
    const roleOk = !requiredRoles?.length || hasAnyRole(requiredRoles);

    if (!permissionOk || !roleOk) {
        return <Navigate to="/access-denied" replace state={{ from: location.pathname }} />;
    }

    return <>{children ?? <Outlet />}</>;
};
